<i18n>
{
  "fr": {
    "layerGroupInfo-title": "Information sur la carte",
    "legend-title": "Légende"
  },
  "de": {

  }
}
</i18n>

<template>
  <div class="container tool" v-if="show">
    <h3>{{ layerGroupInfo.groupMetadata.name }}</h3>
    <p class="desc" v-html="layerGroupInfo.groupMetadata.description"></p>
    <div class="legend" v-for="legend in legends" :key="legend.id">
      <h4 v-if="legend.name !== null" v-html="legend.name"></h4>
      <div class="legend-wrapper">
        <span class="legend-tooltip" v-for="legendTooltip in legend.tooltips" :key="legendTooltip.top"
          :style="{ top: legendTooltip.top, left: legendTooltip.left }">
          <md-tooltip md-direction="left">{{ legendTooltip.content[$i18n.locale] }}</md-tooltip>
        </span>
        <img v-if="legend.showLegend" :src="legend.url" />
      </div>
    </div>
  </div>
</template>

<script>

import LayerStoreMixin from '@/mixins/store/layer'

export default {
  name: 'layerGroupDescription',
  mixins: [
    LayerStoreMixin
  ],
  computed: {
    show () {
      return this.layerGroupInfo !== null
    },
    legends () {
      let toReturn = []
      if (typeof this.layerGroupInfo.webviewConfig.legendSourceIds === 'undefined') return toReturn
      let legendLayers = this.currentLayers.filter((layer) => this.layerGroupInfo.webviewConfig.legendSourceIds.includes(layer.sourceId))
      let legendTool
      legendLayers.forEach((legendLayer) => {
        legendTool = legendLayer.webviewConfig.availableTools.find((tool) => tool.key === 'LEGEND_INFO')
        toReturn.push({
          name: typeof legendTool?.params?.legendName === 'undefined' ? null : legendTool.params.legendName[this.$i18n.locale],
          url: `${legendLayer.getSource().getLegendUrl()}&sld_version=1.1.0`,
          tooltips: typeof legendTool?.params?.legendTooltips === 'undefined' ? [] : legendTool.params.legendTooltips,
          showLegend: legendLayer.webviewConfig?.showLegend ?? true
        })
      })
      return toReturn
    }
  }
}

</script>

<style lang="scss" scoped>
  .desc {
    text-align: justify;
  }

  .legend {
    h4 {
      line-height: 20px;
      margin-bottom: 7px;
      margin-top: 7px;
    }
  }

  .legend-wrapper {
    position: relative;
    .legend-tooltip {
      position: absolute;
      width: 25px;
      height: 25px;
      display: block;
    }
  }
</style>
